import { NoDataOptions } from 'highcharts';

export const noDataOptions: NoDataOptions = {
    style: {
        fontWeight: 'normal',
        fontSize: '16px',
        color: 'rgba(0,0,0,.4)'
    }
};